/**
 * Environment Configuration for Revatek Connect
 * Firebase v11+ optimized for React 19+ with zero re-render configuration
 * @module environment
 */

// Optimized env accessor - ES2022+ nullish coalescing with validation
const env = (key, fallback = null, required = true) => {
  const value = import.meta.env[key]
  if (required && !value) {
    console.error(`Missing required environment variable: ${key}`)
    return fallback
  }
  return value ?? fallback
}

/**
 * Firebase v11+ Configuration - Immutable & optimized for React 19+
 * @type {import('firebase/app').FirebaseOptions}
 */
export const firebaseConfig = Object.freeze({
  apiKey: env('VITE_FIREBASE_API_KEY'),
  authDomain: env('VITE_FIREBASE_AUTH_DOMAIN'),
  projectId: env('VITE_FIREBASE_PROJECT_ID'),
  storageBucket: env('VITE_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('VITE_FIREBASE_MESSAGING_SENDER_ID'),
  appId: env('VITE_FIREBASE_APP_ID'),
  measurementId: env('VITE_FIREBASE_MEASUREMENT_ID', null, false),
})

// Environment flags - React 19+ compatible constants
export const isDevelopment = import.meta.env.DEV
export const isProduction = import.meta.env.PROD
export const useFirebaseEmulators = env('VITE_USE_FIREBASE_EMULATORS', 'false', false) === 'true'

/**
 * Service URLs - Optimized configuration object
 * @type {Readonly<{cloudFunctions: string, emulators: Readonly<{auth: string, firestore: {host: string, port: number}, functions: {host: string, port: number}}>}>}
 */
export const serviceUrls = Object.freeze({
  cloudFunctions: env('VITE_CLOUD_FUNCTIONS_BASE_URL', 'http://localhost:5003', false),
  emulators: Object.freeze({
    auth: 'http://localhost:9097',
    firestore: { host: 'localhost', port: 8082 },
    functions: { host: 'localhost', port: 5003 },
  }),
})
